import React from "react";
import PropTypes from "prop-types";

const findProgramDirectorName = (programDirectors, programDirectorId) => {
  var programDirector = programDirectors.find(
    (programDirector) => programDirectorId == programDirector.id
  )
  if (programDirector) {
    return programDirector.full_name_reverse
  } else {
    "error"
  }
};

const findInstructorTrainerName = (instructorTrainers, instructorTrainerId) => {
  var instructorTrainer = instructorTrainers.find(
    (instructorTrainer) => instructorTrainerId == instructorTrainer.id
  )
  if (instructorTrainer) {
    return instructorTrainer.full_name_reverse
  } else {
    "error"
  }
};

const findTrainingCenterName = (trainingCenters, trainingCenterId) => {
  var trainingCenter = trainingCenters.find(
    (trainingCenter) => trainingCenterId == trainingCenter.id
  )
  if (trainingCenter) {
    return trainingCenter.name
  } else {
    "error"
  }
};

const StepResultViewOnly = ({
  stepResult,
  certificationStep,
  programDirectors,
  instructorTrainers,
  trainingCenters
}) => (
  <React.Fragment>
    <td>{certificationStep.name}</td>
    <td>
      {stepResult.completed_on ? moment(stepResult.completed_on).format("YYYY-MM-DD") : null}
    </td>
    <td>
      {findProgramDirectorName(programDirectors, stepResult.program_director_id)}
    </td>
    <td>
      {findInstructorTrainerName(instructorTrainers, stepResult.instructor_trainer_id)}
    </td>
    <td>
      {findTrainingCenterName(trainingCenters, stepResult.training_center_id)}
    </td>
  </React.Fragment>
)

StepResultViewOnly.propTypes = {
  stepResult: PropTypes.object,
  certificationStep: PropTypes.object,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array
};

export default StepResultViewOnly;
